export const updatePageSEO = (config: {
  title?: string;
  description?: string;
  keywords?: string;
  canonical?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
  ogUrl?: string;
  ogImage?: string;
  jsonLd?: object;
}) => {
  // Update title
  if (config.title) {
    document.title = config.title;
  }

  // Update or create meta tags
  const updateMetaTag = (name: string, content: string, isProperty = false) => {
    const attribute = isProperty ? 'property' : 'name';
    let element = document.querySelector(`meta[${attribute}="${name}"]`);
    if (!element) {
      element = document.createElement('meta');
      element.setAttribute(attribute, name);
      document.head.appendChild(element);
    }
    element.setAttribute('content', content);
  };

  if (config.description) {
    updateMetaTag('description', config.description);
  }

  if (config.keywords) {
    updateMetaTag('keywords', config.keywords);
  }

  if (config.ogTitle) {
    updateMetaTag('og:title', config.ogTitle, true);
    updateMetaTag('twitter:title', config.ogTitle);
  }

  if (config.ogDescription) {
    updateMetaTag('og:description', config.ogDescription, true);
    updateMetaTag('twitter:description', config.ogDescription);
  }

  if (config.ogType) {
    updateMetaTag('og:type', config.ogType, true);
  }

  if (config.ogUrl) {
    updateMetaTag('og:url', config.ogUrl, true);
  }

  if (config.ogImage) {
    updateMetaTag('og:image', config.ogImage, true);
    updateMetaTag('twitter:image', config.ogImage);
  }

  // Update canonical link
  if (config.canonical) {
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = config.canonical;
  }

  // Update or create JSON-LD
  if (config.jsonLd) {
    // Remove existing JSON-LD
    const existingJsonLd = document.querySelector('script[type="application/ld+json"]');
    if (existingJsonLd) {
      existingJsonLd.remove();
    }

    // Add new JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(config.jsonLd);
    document.head.appendChild(script);
  }

  // Update last-modified date
  const lastModified = new Date().toISOString().split('T')[0];
  updateMetaTag('last-modified', lastModified);
};

export const getSiteUrl = (): string => {
  return import.meta.env.VITE_SITE_URL || 'https://example.com';
};
